// extracted by mini-css-extract-plugin
module.exports = {"homeCornerMark":"index-module_homeCornerMark_AsMWL"};